import React, {useEffect, useState} from 'react';
import './index.scss';
import {Menu, Col, Row, Typography, Checkbox, Divider, notification, Tag, Modal, Space, Spin, TreeSelect} from 'antd';
import {StockOutlined, UnorderedListOutlined, CheckCircleTwoTone, DollarOutlined} from '@ant-design/icons';
import ProductCardGrid from '../components/ProductCardGrid/ProductCardGrid';
import {useTranslation} from 'react-i18next';
import Search from 'antd/es/input/Search';
import API_SERVICE from 'shared/services/api-service';
import {useLayoutMedia} from 'shared/services/Utility';
import {useLocation} from 'react-use';
import {useHistory} from 'react-router-dom';

const {SubMenu} = Menu;
const rootSubmenuKeys = ['Category', 'Level', 'Plan'];

const {Title} = Typography;
export default function CourseListPage(props: any) {
  const location = useLocation();
  let params: any;
  params = new URLSearchParams(location.search);

  const {t} = useTranslation();
  const history = useHistory();
  const [categories, setCategories] = useState([] as any[]);
  const [search, setSearch] = useState(params.get('search') || '');
  const [completingPayment, setCompletingPayment] = useState(false);
  const [levels, setLevels] = useState([] as any[]);
  const [selectedCategory, setSelectedCategory] = useState(params.get('categoryId') || -1);
  const [isFeatured, setIsFeatured] = useState(params.get('isFeatured') === 'true');
  const [isPopular, setIsPopular] = useState(params.get('isPopular') === 'true');
  const [selectedLevel, setSelectedLevels] = useState(-1);
  const [selectedPlan, setSelectedPlan] = useState('' as string);
  const [openKeys, setOpenKeys] = React.useState([] as any[]);
  // @ts-ignore
  const refreshMetaData = async () => {
    try {
          const {
            data: { data: c },
          } = await API_SERVICE.fetchSubCategories({ per_page: 1000 });
          setCategories(c);
          console.log("dadadada",c)
        } catch (e) {
        notification.error({
            message: t(API_SERVICE.handleErrors(e)),
        });
    }
};
  useEffect(() => {
    refreshMetaData();
  },[])
  useEffect(() => {
    if (params.get('PayerID') && params.get('token')) {
      setCompletingPayment(true);
      API_SERVICE.completePurchase({payment_order_id: params.get('token')}).then((d) => {
        setCompletingPayment(false);
      }).catch((e) => {
        notification.error({message: API_SERVICE.handleErrors(e)});
      });
    }
    if (location.search) {
      if (params) {
        if (params.get('search')) {
          setSearch(params.get('search') as string);
        }
        if (params.get('isFeatured')) {
          setIsFeatured(true);
        }
      }
    }
    // API_SERVICE.fetchCategories({per_page: 1000}).then((categories) => {
    //   if (params && params.get('categoryId')) {
    //     setSelectedCategory(parseInt(params.get('categoryId') as string));
    //   }
    //   setCategories(categories.data.data.items);
    // }).catch((e) => {
    //   notification.error({
    //     message: API_SERVICE.handleErrors(e),
    //   });
    // });
    
    API_SERVICE.fetchLevels({per_page: 1000}).then((levels) => {
      setLevels(levels.data.data.items);
    }).catch((e) => {
      notification.error({
        message: API_SERVICE.handleErrors(e),
      });
    });
  }, [location]);
  const onOpenChange = (keys: any[]) => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  const [value, setValue] = useState<string>();
    
      const onChange = (newValue: string) => {
        console.log(newValue);
        setValue(newValue);
        setSelectedCategory(newValue === selectedCategory ? -1 : newValue)
      };
  return (
    <div className={'product-list-page-wrapper container-fluid plr-4rem'}>
      {
        params.get('token') &&
        <Modal cancelButtonProps={{hidden: true}} onCancel={() => history.push('/my/courses')}
               onOk={() => history.push('/my/courses')}
               okButtonProps={{loading: completingPayment}}
               visible={true} width={400}>
          {
            completingPayment &&
            <Row gutter={[20, 20]}>
              <Col span={24} className={'text-center'}>
                <Spin size={'large'}/>
              </Col>
              <Col span={24} className={'text-center'}>
                <Title level={3}>{t('genDict.processingPayment')}</Title>
              </Col>
            </Row>
          }
          {
            !completingPayment &&
            <Row gutter={[20, 20]}>
              <Col span={24} className={'text-center'}>
                <CheckCircleTwoTone style={{fontSize: '100px'}}/>
              </Col>
            </Row>
          }
        </Modal>
      }
      <Row className={'layout-wrapper'}>
        { 
          // !useLayoutMedia(['Mobile']) &&
           location.pathname !== '/my/favourites/courses' && location.pathname !== '/my/courses' &&  <Col lg={24} md={24} sm={24} xs={24}>
            <div className="ml-3 mr-3">
              {/* <Title className={'title'} level={4}>
                {t('genDict.filter')}
              </Title> */}
              <div className='d-flex'>
                <Menu
                  openKeys={openKeys} onOpenChange={onOpenChange}
                  mode="inline"
                  className='d-flex pt-2 pt-sm-0 w-auto ml-auto flex-wrap align-items-center'
                >
                  <div className="search pl-2">
                    <Search value={search} allowClear placeholder={t('genDict.search')} onChange={(e) => {
                      setSearch(e.target.value);
                    }} enterButton/>
                  </div>
                  <TreeSelect
                      showSearch
                      treeNodeFilterProp='title'
                      style={{ width: '250px' }}
                      value={selectedCategory !== -1 && selectedCategory}
                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                      placeholder="Please select"
                      allowClear
                      treeDefaultExpandAll={false}
                      className={'ml-2'}
                      onChange={onChange}
                      treeData={categories}
                  />
                  {/* <SubMenu icon={<UnorderedListOutlined/>} title="Category" key="Category">
                    <div className="category-wrapper">
                      {categories.map((c) => {
                        return <div key={c.id}>
                          <Checkbox
                            onChange={() => setSelectedCategory(c.id === selectedCategory ? -1 : c.id)}
                            checked={selectedCategory === c.id}>{c.name}</Checkbox>
                        </div>;
                      })}
                    </div>
                  </SubMenu> */}
                  <SubMenu icon={<StockOutlined/>} title="Level" key="Level">
                    <div className="category-wrapper">
                      {levels.map((c) => {
                        return <div key={c.id}>
                          <Checkbox
                            onChange={() => setSelectedLevels(c.id === selectedLevel ? -1 : c.id)}
                            checked={selectedLevel === c.id}>{c.name}</Checkbox>
                        </div>;
                      })}
                    </div>
                  </SubMenu>
                  {/* <SubMenu icon={<DollarOutlined/>} title="Plan" key="Plan">
                    <div className="category-wrapper">
                      {['free', 'paid'].map((c) => {
                        return <div key={c}>
                          <Checkbox onChange={() => setSelectedPlan(c === selectedPlan ? '' : c)}
                                    checked={selectedPlan === c}>{c}</Checkbox>
                        </div>;
                      })}
                    </div>
                  </SubMenu> */}
                  {/* <div style={{paddingLeft: '22px', marginTop: '10px'}}>
                    <Checkbox onChange={(e) => setIsFeatured(e.target.checked)}
                              checked={isFeatured}>{t('course.isFeatured.label')}</Checkbox>
                  </div>
                  <div style={{paddingLeft: '22px', marginTop: '10px'}}>
                    <Checkbox onChange={(e) => setIsPopular(e.target.checked)}
                              checked={isPopular}>{t('course.isPopular.label')}</Checkbox>
                  </div> */}
                </Menu>
              </div>
            </div>
          </Col>
        }
        <Col className={''} lg={24} md={24} sm={24} xs={24}>
          <Row gutter={5} style={{marginBottom: '10px'}}>
            
            {/* {
              selectedCategory > -1 && categories.length > 0 && <Col>
              {console.log('selectedCategory',selectedCategory)}
                <Tag closable onClose={() => setSelectedCategory(-1)}>
                  {
                    categories.find((c) => c.value == selectedCategory)?.title
                  }
                </Tag>
              </Col>
            } */}
            {/* {
              selectedLevel > -1 && <Col>
                <Tag closable onClose={() => setSelectedLevels(-1)}>
                  {
                    levels.find((c) => c.id === selectedLevel).name
                  }
                </Tag>
              </Col>
            } */}
            {
              selectedPlan && <Col>
                <Tag closable onClose={() => setSelectedPlan('')}>
                  {
                    selectedPlan
                  }
                </Tag>
              </Col>
            }
            {
              search && <Col>
                <Tag closable onClose={() => setSearch('')}>
                  {
                    search
                  }
                </Tag>
              </Col>
            }
          </Row>

          <ProductCardGrid search={search} selectedCategory={selectedCategory} isFeatured={isFeatured}
                           isPopular={isPopular} selectedLevel={selectedLevel}
                           selectedPlan={selectedPlan}/>
        </Col>
      </Row>
    </div>
  );
}
